import Bugsnag from "@bugsnag/js";
import bugsnagReact from "@bugsnag/plugin-react";
import React, { FunctionComponent, ReactNode } from "react";
import { getMetaContent } from "@Utils/meta";

const releaseStage = getMetaContent("cheerz-env");
const appVersion = getMetaContent("cheerz-front-release");
const apiKey = process.env.REACT_APP_BUGSNAG_API_KEY;

if (!apiKey) {
  throw new Error("Missing env REACT_APP_BUGSNAG_API_KEY");
}

Bugsnag.start({
  apiKey,
  appVersion,
  enabledReleaseStages: ["production", "staging"],
  plugins: [new bugsnagReact()],
  releaseStage,
});

export const BugsnagErrorBoundary = Bugsnag.getPlugin("react")?.createErrorBoundary(React);

export const WithBugsnag: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  return BugsnagErrorBoundary ? (
    <BugsnagErrorBoundary>{children}</BugsnagErrorBoundary>
  ) : (
    <>{children}</>
  );
};
